<h1 mat-dialog-title>Report {{ data.itemType }}</h1>
<div mat-dialog-content>
  <app-error-message [message]="error"></app-error-message>
  <div class="content-group">
    <div class="label">เนื้อหา</div>
    <div class="content-view" [innerHTML]="data.content"></div>
  </div>
  <div class="content-group">
    <div class="label">เจ้าของโพสต์</div>
    <div class="content-view">{{ data.user }}</div>
  </div>
  <div class="content-group">
    <div class="label">เหตุผลที่แจ้ง</div>
    <app-text-input placeholder="Reason" [maxLength]="255" [(value)]="reason"></app-text-input>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    [appThemedButton]="data.theme"
    [disabled]="isLoading || isReasonInvalid"
    (click)="submit()"
  >
    Submit
  </button>
  <button mat-button class="button-right" [disabled]="isLoading" (click)="cancel()">Cancel</button>
</div>
